/**
 * BackLink — the single "go back one level" affordance for in-client pages.
 *
 * Before this existed, the same action ("return to the editor hub") appeared as
 * "← Back to editor hub", "← Back to client", "← Back to client (don't approve
 * yet)", and a bare "Cancel" button — four labels, rendered sometimes as a Link
 * and sometimes as a navigate() button. One component, one look, one default
 * label, so the vocabulary can't drift again.
 *
 * PROPS
 *   to       — destination path (used when there's no onNavigate guard).
 *   onNavigate — optional (path) => void. Pages with an unsaved-changes guard
 *                pass handleNavAttempt so Back routes through the same check.
 *   children — optional label override. Defaults to "← Back to editor hub".
 *              Pass your own for non-hub destinations (e.g. "← Back to interviews").
 *              The "←" is part of the default; include it in overrides too.
 *
 * Renders a real <Link> when unguarded (right-click / open-in-new-tab work),
 * and a button when guarded (so the guard can intercept).
 */

import React from "react";
import { Link } from "react-router-dom";

export default function BackLink({ to, onNavigate, children }) {
  const label = children || "← Back to editor hub";
  if (onNavigate) {
    return (
      <button type="button" style={s.btn} onClick={() => onNavigate(to)}>
        {label}
      </button>
    );
  }
  return <Link to={to} style={s.link}>{label}</Link>;
}

const s = {
  link: {
    fontSize: "var(--text-sm)",
    color: "var(--color-text-secondary)",
    textDecoration: "none",
    background: "none",
    border: "none",
    padding: 0,
    cursor: "pointer",
    alignSelf: "flex-start",
    display: "inline-block",
  },
  btn: {
    fontSize: "var(--text-sm)",
    color: "var(--color-text-secondary)",
    textDecoration: "none",
    background: "none",
    border: "none",
    padding: 0,
    cursor: "pointer",
    alignSelf: "flex-start",
    font: "inherit",
  },
};
